/**
 * Initializes the alert service for the web by setting up an showNotification (Portal) handler.
 * Once initialized, alerts can be displayed anywhere in the app by calling alertService.alert()
 */

import { IAlertHandler, IWebAlertParams, alertService } from '@webtrader/core/services/alert';

import { showNotification } from '@/components/Notification';

export const useInitWebAlert = () => {
  const webAlert: IAlertHandler = {
    alert: (params: IWebAlertParams) => {
      const { type, title, message, delay } = params;
      showNotification({
        type: type || 'success',
        title: title || '',
        message,
        delay: delay || 4000
      });
    }
  };

  alertService.setAlertHandler(webAlert);
};
